import Sports from "../components/Content/sports";
import GameShow from "../components/Content/game_show";
import Award from "../components/Content/award";
import News from "../components/Content/news";
import { PageHeader } from "../components/admin";

const CATEGORIES = [
  { id: "news", label: "News" },
  { id: "sports", label: "Sports" },
  { id: "gameshows", label: "Game Shows" },
  { id: "awards", label: "Awards" },
];

function Content({ category, selectedItem }) {
  const renderContent = () => {
    switch (category) {
      case "sports":
        return <Sports />;
      case "gameshows":
        return <GameShow />;
      case "awards":
        return <Award />;
      case "news":
        return <News />;
      default:
        return (
          <div className="space-y-6">
            <PageHeader
              title="Content Management"
              description="Pick a category to manage its content"
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {CATEGORIES.map((cat) => (
                <div key={cat.id} className="card p-5 text-center">
                  <p className="text-white font-medium">{cat.label}</p>
                  <p className="text-xs text-gray-500 mt-1">Manage from the sidebar</p>
                </div>
              ))}
            </div>
          </div>
        );
    }
  };

  return <div>{renderContent()}</div>;
}

export default Content;
